module.exports = __webpack_public_path__ + "static/media/gg_logo.1249d880.png";